import useEffectiveWorkflowRunFilters from '@UI/Pages/WorkflowRuns/Hooks/useEffectiveWorkflowRunFilters';
import workflowRunFiltersSignal, {
	setWorkflowRunFilters,
} from '@UI/Pages/WorkflowRuns/Filters/Signals/workflowRunFiltersSignal';
import formFieldStylesPt from '@UI/Pages/WorkflowRuns/Filters/Helpers/formFieldStylesPt';
import * as React from 'react';
import type BeneficiaryDirectoryEntryView from '@UI/Store/Beneficiaries/Views/BeneficiaryDirectoryEntryView';
import { Dropdown } from '@verclam/ui-kit';

type Props = {
	readonly options: readonly BeneficiaryDirectoryEntryView[];
};

const BeneficiaryFilter: React.FC<Props> = ({ options }) => {
	const filters = useEffectiveWorkflowRunFilters();

	const handleBeneficiaryChange = React.useCallback((beneficiaryId: number | null) => {
		setWorkflowRunFilters(workflowRunFiltersSignal.peek().setBeneficiaryId(beneficiaryId));
	}, []);

	return (
		<Dropdown<number>
			name="workflowRunBeneficiary"
			label="Bénéficiaire"
			placeholder="Tous les bénéficiaires"
			options={[...options]}
			optionLabel="fullName"
			optionValue="id"
			filter
			showClear
			value={filters.beneficiaryId}
			onChange={handleBeneficiaryChange}
			pt={formFieldStylesPt}
		/>
	);
};

export default BeneficiaryFilter;
